import LoginDialog from './components/';
import * as auth from './core/';
export { LoginDialog };
export default auth;
